import React, { memo } from "react";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  TextField,
  IconButton,
  Grid,
  Autocomplete,
  Tooltip,
  FormControl,
  InputLabel,
} from "@mui/material";
import { motion } from "framer-motion";

//FUNCTION
function AddGoodsReceiveItems({
  itemList,
  handleAutocompleteChange,
  handleAddItem,
  handleDeleteItem,
  items,
  handleQuantityChange,
  errors,
  orderQtyReadOnly,
}) {
  // Custom filter to search by both item name and item code
  const filterOptions = (options, { inputValue }) => {
    if (!inputValue) return options;
    
    const lowercasedInput = inputValue.toLowerCase();
    return options.filter((option) => {
      const nameMatch = (option.item_name || "").toLowerCase().includes(lowercasedInput);
      const codeMatch = (option.item_code || "").toLowerCase().includes(lowercasedInput);
      return nameMatch || codeMatch;
    });
  };
  return (
    <>
      <div>
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#f2f0fc",
            padding: 10,
            borderRadius: "10px",
            border: "none",
            margin: "5px 0px",
            display: "flex",
            justifyContent: "center",
          }}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <div>
            {itemList.map((item, index) => (
              <div key={item.id}>
                <Grid
                  container
                  alignItems={"center"}
                  spacing={1}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  key={item.id}
                  sx={{ mb: 1 }}
                >
                  <Grid item xs={12} sm={3} md={3}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      value={
                        item.item_id
                          ? items.find(
                              (it) =>
                                it.id.toString() === item.item_id.toString()
                            )
                          : null
                      }
                      options={items}
                      filterOptions={filterOptions}
                      getOptionLabel={(option) =>
                        option ? `${option.item_name} (${option.item_code})` : ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderOption={(props, option) => (
                        <li {...props}>
                          {option.item_name} ({option.item_code})
                        </li>
                      )}
                      onChange={(event, newValue) =>
                        handleAutocompleteChange(event, newValue, item.id)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            backgroundColor: "white",
                            border: "1px solid #c4c4c4",
                          }}
                          size="small"
                          label="Item Name / Item Code"
                          variant="outlined"
                          name="item_id"
                          error={errors[index]?.itemFullname !== undefined}
                          helperText={errors[index]?.itemFullname}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="HSN Code"
                      variant="outlined"
                      name="hsn_code"
                      value={item.hsn_code}
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        backgroundColor: "#f5f5f5",
                        border: "1px solid #c4c4c4",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Order Qty"
                      variant="outlined"
                      name="order_qty"
                      type="number"
                      value={item.order_qty}
                      onChange={(e) =>
                        handleQuantityChange(e, item.id, "order_qty")
                      }
                      sx={{
                        backgroundColor: orderQtyReadOnly ? "#f5f5f5" : "white",
                        border: "1px solid #c4c4c4",
                      }}
                      inputProps={{ step: "0.01" }}
                      InputProps={{ readOnly: orderQtyReadOnly }}
                      disabled={orderQtyReadOnly}
                      error={errors[index]?.order_qty !== undefined}
                      helperText={errors[index]?.order_qty}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Received Qty"
                      variant="outlined"
                      name="received_qty"
                      type="number"
                      value={item.received_qty}
                      onChange={(e) =>
                        handleQuantityChange(e, item.id, "received_qty")
                      }
                      sx={{ backgroundColor: "white", border: "1px solid #c4c4c4" }}
                      inputProps={{ step: "0.01" }}
                      error={errors[index]?.received_qty !== undefined}
                      helperText={errors[index]?.received_qty}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2} md={1}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Rejected Qty"
                      variant="outlined"
                      name="rejected_qty"
                      type="number"
                      value={item.rejected_qty}
                      onChange={(e) =>
                        handleQuantityChange(e, item.id, "rejected_qty")
                      }
                      sx={{ backgroundColor: "white", border: "1px solid #c4c4c4" }}
                      inputProps={{ step: "0.01" }}
                      error={errors[index]?.rejected_qty !== undefined}
                      helperText={errors[index]?.rejected_qty}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2} md={1}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Actual Qty"
                      variant="outlined"
                      value={
                        (parseFloat(item.received_qty || 0) -
                          parseFloat(item.rejected_qty || 0)) || ""
                      }
                      InputProps={{ readOnly: true }}
                      sx={{
                        backgroundColor: "#f5f5f5",
                        border: "1px solid #c4c4c4",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2} md={1}>
                    <Tooltip title="Delete Item">
                      <span>
                        <IconButton
                          onClick={() => handleDeleteItem(item.id)}
                          size="small"
                          sx={{
                            backgroundColor: "#ffebee",
                            "&:hover": {
                              backgroundColor: "#ffcdd2",
                            },
                          }}
                        >
                          <DeleteIcon
                            fontSize="small"
                            sx={{ color: "#c62828" }}
                          />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              </div>
            ))}
            <Grid container sx={{ mt: 1 }}>
              <Tooltip title="Add new item row">
                <AddBoxIcon
                  onClick={handleAddItem}
                  sx={{
                    cursor: "pointer",
                    color: "green",
                    fontSize: "28px",
                  }}
                />
              </Tooltip>
            </Grid>
          </div>
        </motion.div>
      </div>
    </>
  );
}

export default memo(AddGoodsReceiveItems);
